module.exports = __webpack_public_path__ + "static/media/DJs.c238e389.png";